import { render, staticRenderFns } from "./Collector.vue?vue&type=template&id=407ed009&scoped=true"
import script from "./Collector.vue?vue&type=script&lang=js"
export * from "./Collector.vue?vue&type=script&lang=js"
import style0 from "./Collector.vue?vue&type=style&index=0&id=407ed009&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407ed009",
  null
  
)

export default component.exports